<template>
  <div class="app-body">
    <div v-if="!canEditCustomer" class="tips-box">修改该订单请联系订单创建者：{{ dataForm.creatorName }}</div>
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-card>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="合同编号：" prop="code">
              <el-input
                  v-model="dataForm.code"
                  placeholder="请输入合同编号"
                  size="mini"
                  :disabled="!canEditCustomer||$c.str2bool(dataForm.id) "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户：" prop="customerId">
              <customer
                  v-model="dataForm.customerId"
                  :disabled="!canEditCustomer"
                  :showBtn="false"
              ></customer>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易货币：" prop="currency">
              <currency v-model="dataForm.currency" :disabled="!canEditCustomer"></currency>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务担当：" prop="businessMan">
              <user-drop v-model="dataForm.businessMan" :disabled="!canEditCustomer"></user-drop>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="expand">
          <el-col :span="8">
            <el-form-item label="签订日期：" prop="signTime">
              <el-date-picker
                  size="mini"
                  v-model="dataForm.signTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  placeholder="选择签订日期"
                  :disabled="!canEditCustomer"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交付日期：" prop="deadline">
              <el-date-picker
                  size="mini"
                  v-model="dataForm.deadline"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  placeholder="选择交付日期"
                  :disabled="!canEditCustomer"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注：" prop="remark">
              <el-input v-model="dataForm.remark" placeholder="备注" size="mini"
                        :disabled="!canEditCustomer"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="flex justify-center hand">
          <i
              v-if="!expand"
              class="el-icon-arrow-down"
              @click="expand = !expand"
          ></i>
          <i
              v-if="expand"
              class="el-icon-arrow-up"
              @click="expand = !expand"
          ></i>
        </div>
      </el-card>
      <el-card>
        <div slot="header" class="card-header">
          <div>合同明细</div>
          <div>
<!--            <el-button-->
<!--                size="mini"-->
<!--                icon="el-icon-upload"-->
<!--                @click="showOrderDetailDialog()"-->
<!--                type="warning"-->
<!--            >选择历史品番-->
<!--            </el-button-->
<!--            >-->
            <el-button
                size="mini"
                icon="el-icon-upload"
                @click="showCommonDialog()"
                type="warning"
                v-if="canEditCustomer"
            >读取文件</el-button>
            <el-button
                size="mini"
                icon="el-icon-upload"
                @click="showMutileBomSaveDialog"
                type="primary"
                v-if="canEditCustomer"
            >批量设置单耗
            </el-button
            >
            <el-button
                size="mini"
                icon="el-icon-plus"
                @click="showDetailSaveDialog()"
                type="primary"
                v-if="canEditCustomer"
            >增加明细
            </el-button
            >
          </div>
        </div>
        <el-table
            :data="dataForm.detailList"
            border
            style="width: 100%"
            :summary-method="getSummaries"
            show-summary
            @selection-change="detailSelectionChangeHandle"
        >
          <el-table-column
              type="selection"
              width="60"
              header-align="center"
              align="center"
              fixed="left"
          ></el-table-column>
          <el-table-column
              type="index"
              label="行号"
              width="60"
              header-align="center"
              align="center"
              fixed="left"
          ></el-table-column>
          <el-table-column label="品番号" width="170" prop="code" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="SKU" width="170" prop="skuCode" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="品名" align="center" prop="name">
          </el-table-column>
          <el-table-column label="中文品名" width="170" align="center" prop="nameZh">
          </el-table-column>
          <el-table-column
              label="颜色"
              prop="color"
              header-align="center"
              align="center"
              width="140"
          >
          </el-table-column>
          <el-table-column
              label="规格"
              prop="size"
              header-align="center"
              align="center"
              width="140"
          >
          </el-table-column>
          <el-table-column
              label="返单号"
              prop="backCount"
              header-align="center"
              align="center"
              width="140"
          >
          </el-table-column>
          <el-table-column
              label="合同数量"
              prop="count"
              header-align="center"
              align="center"
              width="120"
              fixed="right"
          >
          </el-table-column>
          <el-table-column
              label="合同单价"
              header-align="center"
              align="center"
              width="120"
              prop="amount"
              fixed="right"
          >
          </el-table-column>
          <el-table-column
              label="小计"
              header-align="center"
              align="center"
              width="140"
              fixed="right"
          >
            <template slot-scope="scope">
              {{ computePrice(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              width="210"
              label="操作"
              fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                  type="text"
                  icon="el-icon-remove"
                  @click="delRow(scope.$index, scope.row, 'detailList')"
                  v-if="canEditCustomer"
                  size="mini"
              >
                移除
              </el-button>
              <el-button
                  type="text"
                  icon="el-icon-remove"
                  @click="showDetailSaveDialog(scope.row, scope.$index)"
                  v-if="canEditCustomer"
                  size="mini"
              >
                修改
              </el-button>
              <el-button
                  type="text"
                  icon="el-icon-s-tools"
                  @click="showBomSaveDialog(scope.row, scope.$index)"
                  v-if="canEditCustomer"
                  size="mini"
              >
                {{
                  `单耗设置${
                      scope.row.bomList && scope.row.bomList.length > 0
                          ? '【' + scope.row.bomList.length + '】'
                          : ''
                  }`
                }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-form>
    <div class="footer">
      <el-button @click="cancel()" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" size="mini" v-if="canEditCustomer">{{
          $t('confirm')
        }}
      </el-button>
    </div>
    <BomSave ref="BomSave" @change="bomChanged"></BomSave>
    <DetailSaveDialog
        ref="detailSaveDialog"
        @change="detailSaveHandle"
    ></DetailSaveDialog>
    <common-upload
        ref="commonUpload"
        @success="uploadSuccessHandler"
        uploadUrl="/trade/agreement/detail/import"
        templateUrl="/static/template/合同明细导入模板.xlsx"
        title="合同明细导入"
    ></common-upload>
    <common-upload
        ref="bomUpload"
        @success="bomUploadSuccessHandler"
        uploadUrl="/trade/bom/import"
        templateUrl="/static/template/单耗导入模板.xlsx"
        placeHolder="导入时请参照EXCEL模板格式进行导入。一个sheet是一个产品的单耗,按SHEET顺序进行对应"
        title="单耗导入"
    ></common-upload>
    <OrderDetailDialog :exProductIds="exProductIds" :show-query="true" ref="orderDetailDialog" :need-page="true"
                       @selected="orderDetailSelHandler"></OrderDetailDialog>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import BigNumber from 'bignumber.js'
import SingleFileUpload from '@/components/SingleFileUpload'
import SaveRule from './save-rule'
import moment from 'moment'
import BomSave from '@/views/modules/trade/bom/save'
import DetailSaveDialog from './detail-save.vue'
import OrderDetailDialog from '@/components/order-detail-dialog'

export default {
  mixins: [SaveRule],
  components: { SingleFileUpload, BomSave, DetailSaveDialog, OrderDetailDialog },
  data () {
    return {
      id: '',
      projectId: '',
      dataForm: {},
      currentDetailIndex: [],
      detailSelections: [],
      expand: false,
    }
  },
  computed: {
    exProductIds () {
      if (!this.dataForm.detailList || this.dataForm.detailList.length === 0) {
        return ''
      }
      return this.dataForm.detailList.map(item => item.productId).join(',')
    },
    canEditCustomer () {
      let disabled = false
      let currentUser = this.$store.state.user
      if (currentUser.roleIdList.find(r => r === '1497144338753867777')) {
        return true
      }
      if (this.dataForm.id) {
        if (currentUser.id !== this.dataForm.creator) {
          disabled = true
        }
      }
      return !disabled
    },
  },
  activated () {
    this.id = this.$route.query.id
    this.init()
  },
  methods: {
    /**
     * 历史品番选择回调事件
     * @param e
     */
    orderDetailSelHandler (e) {
      if (e && e.length > 0) {
        this.dataForm.detailList = this.dataForm.detailList.concat(e.map(item => {
          return {
            id: '',
            code: item.product.code,
            skuCode: item.product.skuCode,
            name: item.product.name,
            nameZh: item.product.nameZh,
            color: item.product.color,
            size: item.product.size,
            count: '',
            amount: item.amount,
            bomList: item.bomList,
            productId: item.productId
          }
        }))
      }
      let t = this.exProductIds
    },
    /**
     * 显示历史品番选择弹窗
     */
    showOrderDetailDialog () {
      this.$refs.orderDetailDialog.init()
    },
    detailSelectionChangeHandle (val) {
      this.detailSelections = val
    },
    //单耗导入成功回调
    bomUploadSuccessHandler (e) {
      if (!e || e.length === 0) {
        return
      }
      if (!this.dataForm.detailList || this.dataForm.detailList.length === 0) {
        return
      }
      this.dataForm.detailList.forEach((item, index) => {
        item.bomList = [...e[index]]
      })
    },
    uploadSuccessHandler (e) {
      if (e && e.length > 0) {
        e.forEach((item, index) => {
          item.id = index
          item.bomList = []
        })
      }
      this.$set(this.dataForm, 'detailList', e)
      let t = this.exProductIds
      // this.dataForm.detailList = [...e]
    },
    //显示单耗导入弹窗
    showBomUploadDialog () {
      if (!this.dataForm.detailList || this.dataForm.detailList.length === 0) {
        return this.$message.error('请先设置合同明细')
      }
      this.$refs.bomUpload.init()
    },
    //显示通用导入弹窗
    showCommonDialog () {
      this.$refs.commonUpload.init()
    },
    //显示明细编辑窗口
    showDetailSaveDialog (row, index) {
      if (index !== undefined) {
        this.currentDetailIndex = [index]
      } else {
        this.currentDetailIndex = []
      }
      if (row) {
        this.$refs.detailSaveDialog.dataForm = this.$clone(row)
        this.$refs.detailSaveDialog.init(false)
      } else {
        this.$refs.detailSaveDialog.init(true)
      }
    },
    //明细编辑回调
    detailSaveHandle (e) {
      console.log(this.currentDetailIndex)
      if (this.currentDetailIndex && this.currentDetailIndex.length > 0) {
        e.id = this.dataForm.detailList[this.currentDetailIndex[0]].id
        this.$set(
            this.dataForm.detailList,
            this.currentDetailIndex[0],
            this.$clone(e)
        )
      } else {
        e.id = this.dataForm.detailList.length
        this.dataForm.detailList.push(this.$clone(e))
      }
      let t = this.exProductIds
    },
    bomChanged (e) {
      if (e && e.length > 0) {
        for (let i = e.length - 1; i >= 0; i--) {
          const item = e[i]
          if (!item.name) {
            e.splice(i, 1)
          }
        }
      }
      if (this.currentDetailIndex && this.currentDetailIndex.length > 0) {
        this.currentDetailIndex.forEach((c) => {
          this.dataForm.detailList[c].bomList = [...e]
        })
      }
    },
    showMutileBomSaveDialog () {
      if (!this.detailSelections || this.detailSelections.length === 0) {
        return this.$message.error('请选择要设置单耗的品番')
      }
      let tmp = []
      this.detailSelections.forEach((d) => {
        this.dataForm.detailList.forEach((item, index) => {
          if (d.id === item.id) {
            tmp.push(index)
          }
        })
      })
      this.currentDetailIndex = tmp
      this.$refs.BomSave.init()
      this.$refs.BomSave.dataForm.detailList = this.$clone(
          this.detailSelections[0].bomList
      )
    },
    showBomSaveDialog (row, index) {
      this.currentDetailIndex = [index]
      this.$refs.BomSave.init()
      this.$refs.BomSave.dataForm.detailList = this.$clone(row.bomList)
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      sums[0] = '合计'
      let totalAmount = new BigNumber(0)
      data.forEach((row) => {
        const count = new BigNumber(row['count'])
        const price = new BigNumber(row['amount'])
        if (count.isNaN() || price.isNaN()) {
          return
        }
        totalAmount = totalAmount.plus(count.multipliedBy(price))
      })
      sums[columns.length - 2] = totalAmount.toFixed(2)
      return sums
    },
    computePrice (row) {
      if (!row.count || !row.amount) {
        return '-'
      }
      let c = new BigNumber(row.count)
      let p = new BigNumber(row.amount)
      return c.multipliedBy(p).toFixed(2)
    },
    delRow (index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1)
      }
    },
    reset () {
      this.dataForm = {
        id: '',
        remark: '',
        totalAmount: '',
        code: '',
        currency: '美元',
        signTime: moment().format('yyyy-MM-DD'),
        customerId: '',
        detailList: [],
        businessMan: [],
        creator: ''
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
          .get(`/trade/agreement/${this.id}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            if (res.data) {
              if (res.data.businessMan) {
                res.data.businessMan = res.data.businessMan.split(';')
              } else {
                res.data.businessMan = []
              }
              if (res.data.detailList && res.data.detailList.length > 0) {
                res.data.detailList.forEach((item) => {
                  if (!item.bomList) {
                    item.bomList = []
                  }
                })
              }
            }
            this.dataForm = {
              ...this.dataForm,
              ...res.data,
            }
            console.log(this.dataForm.businessMan)
          })
          .catch(() => {
          })
    },
    cancel () {
      this.$router.replace(`/trade-agreement-index`)
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = this.$clone(this.dataForm)
            if (postForm.businessMan) {
              postForm.businessMan = postForm.businessMan.join(';')
            }
            if (postForm.detailList && postForm.detailList.length === 0) {
              return this.$message.error('合同明细不能为空')
            }
            for(let i=0;i<postForm.detailList.length;i++){
              let item=postForm.detailList[i]
              if (item.id < 10000) {
                item.id = ''
              }
              if (!item.count||item.count===0) {
                return this.$message.error(`第${i + 1}行合同数量未设置`)
              }
            }
            const loading = this.$loading()
            this.$http[!postForm.id ? 'post' : 'put'](
                '/trade/agreement/',
                postForm
            )
                .then(({ data: res }) => {
                  loading.close()
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.$router.back()
                    },
                  })
                })
                .catch((e) => {
                  loading.close()
                  console.log(e)
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>

<style lang="scss" scoped>
.app-body {
  padding: 0;
}

.tips-box {
  color: #F56C6C;
  padding: 10px;
  font-size: 18px;
  font-weight: 500;
}
</style>
